import {
  AfterContentInit,
  ElementRef,
  NgZone,
  OnDestroy
} from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';
import SimpleBar from 'simplebar';
import { SimpleBarOptions } from 'simplebar-core';

@Component({
  selector: 'vex-scrollbar',
  template: ` <ng-content></ng-content>`,
  styleUrls: ['./vex-scrollbar.component.scss'],
  host: {
    class: 'vex-scrollbar'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VexScrollbarComponent implements AfterContentInit, OnDestroy {
  @Input() options?: SimpleBarOptions;

  scrollbarRef?: SimpleBar;

  constructor(
    private _element: ElementRef,
    private zone: NgZone
  ) {}

  ngAfterContentInit() {
    this.zone.runOutsideAngular(() => {
      this.scrollbarRef = new SimpleBar(
        this._element.nativeElement,
        this.options
      );
    });
  }

  ngOnDestroy(): void {
    // unMount is available on SimpleBar (see simplebar/dist/index.d.ts)
    this.scrollbarRef?.unMount();
  }
}
